import { FC, ReactNode } from 'react';

import { Cursor, Tooltip } from '../../../../components/tooltip/index';
import { useLocale } from '../../../../hooks/index';
import { StringKey } from '../../../../lang/index';
import { EventTypeBackend } from '../../../../types/events.types';

type BlockedTooltipActionProps = {
  allowed: boolean;
  children: ReactNode;
  messageKey?: StringKey;
  type?: EventTypeBackend;
};

export const BlockedTooltipAction: FC<BlockedTooltipActionProps> = ({
  children,
  allowed,
  messageKey,
  type,
}) => {
  const { messagesLocale } = useLocale();
  const defaultMessageKey =
    type === EventTypeBackend.SAFE_CONVERSION
      ? 'SAFE_CONVERSION_MODIFY_ACTION_BLOCKED'
      : 'EVENT_MODIFY_ACTION_BLOCKED';
  const resolvedKey = messageKey ?? defaultMessageKey;

  return (
    <Tooltip
      className="w-[550px]"
      content={messagesLocale[resolvedKey]}
      cursor={allowed ? Cursor.POINTER : Cursor.DEFAULT}
      disabled={allowed}
    >
      {children}
    </Tooltip>
  );
};
